import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-more',
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.scss'],
})
export class MoreComponent implements OnInit {
  appliance_id: any;
  constructor(public router: Router) {}

  ngOnInit(): void {}

  diagnosis() {
    this.router.navigateByUrl(`/diagnose/${this.appliance_id}`);
  }
}
